export default __webpack_public_path__ + "static/media/img-guide-gt-popup-5-uk_en@3x.bd5b3eeb.png";